"use client"

import clsx from "clsx"
import Image, { ImageProps } from "next/image"
import React from "react"
import Marquee from "react-fast-marquee"

import styles from "@/ui/components/LogosMarquee/LogosMarquee.module.scss"

export const MarqueeLogo: React.FC<ImageProps> = (props) => (
  <div
    className={clsx(
      styles.MarqueeLogoWrapper,
      "marquee-logo-item relative my-0 mx-3.5 md:mx-10 lg:mx-16",
    )}
  >
    <Image
      {...props}
      className={clsx(
        "object-contain absolute inset-0 h-full w-full",
        props?.className,
      )}
    />
  </div>
)

MarqueeLogo.displayName = "MarqueeLogo"

type ReactFastMarqueeProps = React.ComponentProps<typeof Marquee>

type ReactFastMarqueeWithoutChildren = Omit<ReactFastMarqueeProps, "children">

export type MarqueeLogoProps = ReactFastMarqueeWithoutChildren & {
  rowsOfLogos: Array<Array<ImageProps>>
}

// eslint-disable-next-line no-underscore-dangle
const _LogosMarquee: React.FC<MarqueeLogoProps> = (props) => {
  const { rowsOfLogos, ...restOfMarqueeProps } = props

  if (!rowsOfLogos || rowsOfLogos.length === 0) return null

  return (
    <Marquee
      gradient={false}
      speed={30}
      direction="right"
      className={clsx("marquee-logo", restOfMarqueeProps?.className)}
      {...restOfMarqueeProps}
      pauseOnHover={false}
    >
      <div className="flex flex-col gap-10 md:gap-15 lg:gap-20">
        {rowsOfLogos.map((logosRow, index) => (
          // this content is not dynamic, therefore its ok to use index
          // eslint-disable-next-line react/no-array-index-key
          <div className="flex flex-nowrap" key={index}>
            {logosRow.map((logo) => {
              const { key, ...restOfLogo } = logo

              return <MarqueeLogo key={key} {...restOfLogo} />
            })}
          </div>
        ))}
      </div>
    </Marquee>
  )
}

_LogosMarquee.displayName = "MarqueeLogo"

const LogosMarquee = Object.assign(_LogosMarquee, {
  logo: MarqueeLogo,
})

export default LogosMarquee
